import React, {Component} from 'react';

import * as func from "../../../../../../utils/functions";
import RankingItem from './rankingItem';
import {EDIT_MODE} from "../../../../../../wpconfig"

import {array} from 'prop-types';

class PopupKCI extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isEdit: EDIT_MODE.SHOW,
			field: "ranking",
			record : {
				"centrality": null,
				"edition": null,
				"immediacy": null,
				"impact": null,
				"impact_3": null,
				"impact_4": null,
				"impact_5": null,
				"impact_no_self": null,
				"indicator_id": null,
				"indicator_type": "kci",
				"indicator_year": null,
				"ranking": null,
				"self_cite_ratio": null,
				"total_cites": null,
				"total_items": null
			},
			pkKey: "ranking_id"
		};
	}

	componentDidMount() {
    this.props.indicator_id ?
    func.getData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.indicator_id, {}).then((response) => {
      this.setState({
        record: response.record
      })
    }) : (
      console.log("새로등록")
    )
	}

	onEditSave = (e) => {

		const { record } = this.state

		// console.log(record)

		if (this.indicator_year.value === '') {
			this.indicator_year.focus();
		} else {

			if (record.indicator_id) {
				func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + record.indicator_id + "/update", record).then((response) => {
					if (response.code === 'ok') {
						// this.props.showMessage('수정 되었습니다.')
							this.props.togglePopup()
					} else {
						// this.props.showMessage('수정 실패 : ' + response.message)
					}
				})
			} else {
				func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/insert", record).then((response) => {
					if (response.code === 'ok') {
						// this.props.showMessage('추가 되었습니다.')
						// record.indicator_id = response.indicator_id
						this.props.togglePopup()
					} else {
						// this.props.showMessage('추가 실패 : ' + response.message)
					}
				})
			}
		}
	};

	onUpdate = () => {
		// console.log("저장")
		this.onEditSave()
	}

	onChange = (e) => {
		const { record } = this.state

		record[e.target.name] = e.target.value

		this.setState({
			record : record
		})
	}

	onRankingUpdate = (index, item, render) => {
		const { record } = this.state
		record.ranking[index] = item
		console.log(record)
		this.setState({ record : record })
	}

	onRankingRemove = (index, render) => {
		const { record } = this.state
		record.ranking.splice(index, 1);
		this.setState({ record : record })
	}

	onRankingInsert = () => {
		const { record } = this.state
		if (record[this.state.field].length > 0 && record[this.state.field][0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				"ranking_id": "",
				"indicator_type": "kci",
				"category_code": "",
				"category_name": "",
				"category_count": "",
				"ranking": "",
				"percent": "",
				"category_impact": "",
				"is_edit" : EDIT_MODE.SHOW_EDIT,
			}
			this.onEditIndex(0);
			// 데이터 변환 체크하기
			record[this.state.field].unshift(insertRecord)
			this.setState({ record : record })
		}
	}

	onEditIndex(id) {
		if(this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
		})
	}

	render() {

    const { record } = this.state;

		return (
			<>
				<div className="modal d-block pieces_modal PopupKCI" tabIndex="1">
					<div className="modal-dialog">
						<div className="modal-content rm">
							<div className="modal-header">
								<h5 className="modal-title">KCI Indicator</h5>
								<button type="button" className="btn-close" onClick={() => this.props.togglePopup()}></button>
							</div>
							<div className="modal-body">
								<form>
									<div className="container-fluid pl-0 pr-0 m-0 detail-wrap">
										<div className="row mb-2">
											<div className="col-md-2 form-group field-danger">
												<label htmlFor="indicator_type"><strong>Indicator Type</strong></label>
												<input type="text" id="indicator_type" name="indicator_type" className="form-control" readOnly="readOnly" value={ record.indicator_type || 'kci' } onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="indicator_year"><strong>Year</strong></label>
												<input type="text" id="indicator_year" name="indicator_year" ref={(ref)=>this.indicator_year=ref} className="form-control" value={ record.indicator_year || '' } placeholder="2021" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="impact"><strong>KCI Impact(2년)</strong></label>
												<input type="text" id="impact" name="impact" className="form-control" value={ record.impact || '' } placeholder="1.00" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="impact_3"><strong>KCI Impact(3년)</strong></label>
												<input type="text" id="impact_3" name="impact_3" className="form-control" value={ record.impact_3 || '' } placeholder="1.00" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="impact_4"><strong>KCI Impact(4년)</strong></label>
												<input type="text" id="impact_4" name="impact_4" className="form-control" value={ record.impact_4 || '' } placeholder="1.00" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="impact_5"><strong>KCI Impact(5년)</strong></label>
												<input type="text" id="impact_5" name="impact_5" className="form-control" value={ record.impact_5 || '' } placeholder="1.00" onChange={this.onChange}/>
											</div>
										</div>
										<div className="row mb-2">
											<div className="col-md-2 form-group">
												<label htmlFor="impact_no_self"><strong>KCI IF(자기인용제외)</strong></label>
												<input type="text" id="impact_no_self" name="impact_no_self" className="form-control" value={ record.impact_no_self || ''} placeholder="1.00" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="total_cites"><strong>Total Cites</strong></label>
												<input type="text" id="total_cites" name="total_cites" className="form-control" value={ record.total_cites || '' } placeholder="0" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="total_items"><strong>Total Items</strong></label>
												<input type="text" id="total_items" name="total_items" className="form-control" value={ record.total_items || '' } placeholder="0" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="immediacy"><strong>즉시성지수</strong></label>
												<input type="text" id="immediacy" name="immediacy" className="form-control" value={ record.immediacy || '' } placeholder="1.00" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="centrality"><strong>중심성지수(3년)</strong></label>
												<input type="text" id="centrality" name="centrality" className="form-control" value={ record.centrality || '' } placeholder="1.000" onChange={this.onChange}/>
											</div>
											<div className="col-md-2 form-group">
												<label htmlFor="self_cite_ratio"><strong>자기인용비율(2년)</strong></label>
												<input type="text" id="self_cite_ratio" name="self_cite_ratio" className="form-control" value={ record.self_cite_ratio || '' } placeholder="100.00" onChange={this.onChange}/>
											</div>
										</div>
										<div className="row">
											<div className="col d-flex justify-content-end">
												<button type="button" className="btn btn-sm btn-primary mr-1" onClick={this.onUpdate}>저장</button>
												<button type="button" className="btn btn-sm btn-secondary" onClick={() => this.props.togglePopup()}>닫기</button>
											</div>
										</div>
									</div>
								</form>
								{
									record[this.state.field] && 
									(
										<>
											<div className="d-flex mt-4 mb-1">
												<div className="flex-grow-1">
													<h5 className="">카테고리 랭킹 정보</h5>
												</div>
												<div className="btn-group" role="group">
													<button type="button" className="btn btn-sm btn-primary mr-1" onClick={this.onRankingInsert}>신규</button>
												</div>
											</div>
											<div style={{maxHeight: "300px", overflowY: "auto"}}>
												<table className="table table-striped table-thin mb-1 border-bottom">
													<colgroup>
														<col width="90px"></col>
														<col width=""></col>
														<col width="70px"></col>
														<col width="70px"></col>
														<col width="80px"></col>
														<col width="60px"></col>
														<col width="80px"></col>
														<col width="80px"></col>
														<col width="80px"></col>
														<col width="80px"></col>
														<col width="90px"></col>
													</colgroup>
													<thead>
													<tr>
														<th className="pt-2 pb-2">코드</th>
														<th>카테고리</th>
														<th>Edition</th>
														<th>랭킹유형</th>
														<th>총 저널 수</th>
														<th>랭킹</th>
														<th>Percent</th>
														<th>Percentile</th>
														<th>Quartile</th>
														<th>카테고리 IF</th>
														<th>Action</th>
													</tr>
													</thead>
													<tbody>
														{
															record.ranking &&
															record.ranking.map((rData, index) => {
																return (
																	<RankingItem 
																		key={rData[this.state.pkKey]}
																		index={rData[this.state.pkKey]}
																		ref={"ref" + rData[this.state.pkKey]}
																		indicator_id={record.indicator_id}
																		arrIndex={index}
																		pkKey={this.state.pkKey}
																		record={rData}
																		onUpdate={this.onRankingUpdate}
																		onRemove={this.onRankingRemove}
																		// onReload={this.onReload}
																		onEditIndex={this.onEditIndex}
																		// showMessage={this.showMessage}
																	/>
																)
															})
														}
													</tbody>
												</table>
											</div>
										</>
									)
								}
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-sm btn-secondary" onClick={() => this.props.togglePopup()}>닫기
								</button>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}
}

export default PopupKCI;
